export default __webpack_public_path__ + "b85df7bf030b969cd139cacd677652f4.svg";